import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBodyCell } from '@celebration/design-system/dist/lib/table-tbody-cell';

export default createComponent({
    react: React,
    elementClass: ClbTableTBodyCell,
    tagName: ClbTableTBodyCell.tagName,
    events: ClbTableTBodyCell.events,
});
